require('./insuranceRequestWizardStep2.scss');
require('./insuranceRequestWizardStep2.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { merge } = require('lodash');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { EVENTS_INSURANCE_HOME } = require('../../../insuranceConstants/insuranceRequestTags');
const { SECOND_STEP, THIRD_STEP, EURO_SYMBOL, POSTAL_CODE_REGEX } = require('constants/index');
const {
    CONTENT_SLIDER_CONFIG,
    CONTINENT_SLIDER_CONFIG,
    getPropertyTypeOptions,
    PROPERTY_CHARACTER,
    PROPERTY_TYPE,
    PROPERTY_USAGE,
    SIZE_SLIDER_CONFIG,
} = require('../../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_IDD_REGULATION,
    INSURANCE_USABILITY_IMPROVEMENTS,
    INSURANCES_RECOMMENDATION_FACTORS,
    STANDALONE_RELATED_INSURANCE,
} = require('constants/flagBasedFeatures');

// @ commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ components
const InsuranceRequestWizardGuide = require('./insuranceRequestWizardGuide');
const InsurancesRequestWizardStep2SliderLabel = require('./insurancesRequestWizardStep2SliderLabel');
const InsuranceRequestPostalCodePopulation = require('../insuranceRequestPostalCodePopulation/insuranceRequestPostalCodePopulation');

class InsuranceRequestWizardStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lowContinentWarningVisible: false,
            maxContentPassed: false,
            minContinentValue: CONTINENT_SLIDER_CONFIG.MIN,
            postalCode: props.immInsuranceWizardStep.get('postalCode'),
            updateValues: false,
            disablePostalCode: true,
        }

        this.handleChangePropertyCharacter = this.handleChangePropertyCharacter.bind(this);
        this.handleChangeContinent = this.handleChangeContinent.bind(this);
        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.checkDisablePostalCode = this.checkDisablePostalCode.bind(this);
        this.handleSelectPlanModal = this.handleSelectPlanModal.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.saveAndRequestRecommendation = this.saveAndRequestRecommendation.bind(this);
    }

    componentDidMount() {
        const {
            getRecommendation,
            immFlagBasedFeatures,
            immInsuranceWizardStep,
            insuranceRequestFreeStarted,
            insuranceRequesCombinedStarted,
            setData,
        } = this.props;
        const content = immInsuranceWizardStep.get('content');
        const propertyType = immInsuranceWizardStep.get('propertyType');
        const propertyCharacter = immInsuranceWizardStep.get('propertyCharacter');
        const propertyUsage = immInsuranceWizardStep.get('propertyUsage');

        const emptyFields = !propertyCharacter && !propertyType && !propertyUsage;
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);

        const savedData = {
            propertyCharacter,
            propertyType,
            propertyUsage
        }

        this.checkDisablePostalCode(savedData)

        let continent = null;

        const data = {
            content,
            continent,
            propertyCharacter,
            propertyType,
            propertyUsage,
            provinceId: this.getProvinceId(),
            size: immInsuranceWizardStep.get('size'),
        };

        if (data.provinceId) {
            getRecommendation(data);
        }
        setData(SECOND_STEP, {
            noValidateStep: true,
            simulationChanged: false,
        });

        if (__CONTACT_CENTER__) {
            setData(THIRD_STEP, {
                coveragePlanModal: {},
                isQuotationDataChanged: false,
                quotationData: {},
            });
        }

        if (emptyFields && !isInsuranceUsabilityImprovementsEnabled) {
            setData(SECOND_STEP, {
                noValidateStep: true,
                propertyCharacter: PROPERTY_CHARACTER.OWNER,
                propertyType: PROPERTY_TYPE.APARTMENT,
                propertyUsage: PROPERTY_USAGE.PRINCIPAL,
            });
        }

        const isCombined = this.isCombinedMortgaged();

        insuranceRequestFreeStarted(isCombined);

        if(isCombined) {
            this.handleChangePropertyCharacter(PROPERTY_CHARACTER.OWNER);
            insuranceRequesCombinedStarted();
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            immInsuranceState,
            immInsuranceWizardStep,
            setData,
        } = this.props;

        const { updateValues, minContinentValue } = this.state;

        const nextRecommendationContent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'content']);
        const nextSliderContent = nextProps.immInsuranceWizardStep.get('content');
        const nextContinent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'continent']);
        const nextSliderContinent = nextProps.immInsuranceWizardStep.get('continent');

        const minimumValueContinent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'minimumValueContinent']);
        const maxContentValidation = this.getMaxContentValue();

        if (
            updateValues &&
            nextProps.immInsuranceState.get('recommendation') !== immInsuranceState.get('recommendation')
        ) {
            setData(SECOND_STEP, {
                continent: nextContinent < minContinentValue ? minContinentValue : nextContinent
            });

            setData(SECOND_STEP, {
                content: nextRecommendationContent > maxContentValidation ? maxContentValidation : nextRecommendationContent
            });
        }

        const lowContinentWarningVisible = nextSliderContinent < minimumValueContinent;
        const maxContentPassed = nextSliderContent >= maxContentValidation;

        this.setState({ maxContentPassed, lowContinentWarningVisible });

        const currentContent = immInsuranceWizardStep.get('content');
        const contentChanged = nextProps.immInsuranceWizardStep.get('content');
        const currentContinent = immInsuranceWizardStep.get('continent');
        const continentChanged = nextProps.immInsuranceWizardStep.get('continent');
        const currentPopulation = immInsuranceWizardStep.get('populationValue');
        const populationChanged = nextProps.immInsuranceWizardStep.get('populationValue');

        if (currentContent !== contentChanged ||
            currentContinent !== continentChanged ||
            currentPopulation !== populationChanged) {
            setData(SECOND_STEP, {
                simulationChanged: true
            });
        }

        if (!!populationChanged && currentPopulation !== populationChanged) {
            this.saveAndRequestRecommendation({ populationValue: populationChanged });
        }
    }

    getMinContinent() {
        const appraisalImport = this.getLivingPlaceData('appraisalImport');
        const groundPrice = this.getLivingPlaceData('groundPrice');
        const minContinentValue = appraisalImport - groundPrice;
        return Math.max(CONTINENT_SLIDER_CONFIG.MIN, minContinentValue);
    }

    getLivingPlaceData(key) {
        const { immInsuranceState } = this.props;
        const property = immInsuranceState.getIn(['appraisal', 'property']);
        const livingPlaceValue = property.get(key);
        return livingPlaceValue;
    }

    handleChangePropertyCharacter(value) {
        const { immInsuranceWizardStep, recordEvent } = this.props;

        let propertyUsage = immInsuranceWizardStep.get('propertyUsage');
        if (value === PROPERTY_CHARACTER.TENANT) {
            propertyUsage = PROPERTY_USAGE.PRINCIPAL;
        }

        recordEvent(EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_CHARACTER_CHANGE, value);

        this.saveAndRequestRecommendation({
            propertyCharacter: value,
            propertyCharacterIsDirty: true,
            propertyUsageIsDirty: true,
            propertyUsage,
        });
    }

    handleChangeContinent(value) {
        this.props.setData(SECOND_STEP, {
            continent: value
        });
    }

    handleChangeContent(value) {
        this.props.setData(SECOND_STEP, {
            content: value
        });
    }

    handleChange(key, value) {
        const {
            immInsuranceWizardStep,
            recordEvent,
        } = this.props;

        let finalValue = value;

        if (key === 'propertyUsage' || key === 'propertyType') {
            if (key == 'propertyType') {
                const currentValue = immInsuranceWizardStep.get('propertyType');
                finalValue = !!value ? value.value : currentValue;
            }
            const event = key === 'propertyUsage' ?
                EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_USAGE_CHANGE :
                EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_TYPE_CHANGE;
            recordEvent(event, finalValue);
        }

        this.saveAndRequestRecommendation({
            [key]: finalValue,
            [`${key}IsDirty`]: true,
        });
    }

    handleToggleModal() {
        this.props.recordEvent(EVENTS_INSURANCE_HOME.STEP_2_OUR_GUIDE_CLICK);
    }

    getRecommendationData(immInsuranceWizardStep) {
        const defaultData = {
            content: immInsuranceWizardStep.get('content'),
            propertyCharacter: immInsuranceWizardStep.get('propertyCharacter'),
            propertyType: immInsuranceWizardStep.get('propertyType'),
            propertyUsage: immInsuranceWizardStep.get('propertyUsage'),
            size: immInsuranceWizardStep.get('size'),
        };

        return defaultData;
    }

    checkDisablePostalCode (savedData, newData) {
        let keys = ['propertyCharacter', 'propertyUsage', 'propertyType'];
        const keyChanged = newData ? keys.find(key => !!newData[key]) : false;

        if (keyChanged) {
            keys.splice(keys.indexOf(keyChanged), 1);
        }

        const allKeysHaveValue = keys.every(key => !!savedData[key]);
        this.setState({
            disablePostalCode: !allKeysHaveValue
        });
    }

    saveAndRequestRecommendation(newData) {
        const {
            getRecommendation,
            immInsuranceWizardStep,
            setData,
        } = this.props;

        const provinceId = this.getProvinceId();
        const defaultData = this.getRecommendationData(immInsuranceWizardStep);
        const data = merge({}, defaultData, newData);
        setData(SECOND_STEP, data);

        this.checkDisablePostalCode(defaultData, newData);

        if (provinceId) {
            this.setState({
                postalCode: immInsuranceWizardStep.get('postalCode'),
                updateValues: true
            });
            data.provinceId = provinceId;
            getRecommendation(data, true);
        }
    }

    getProvinceId() {
        const { immInsuranceWizardStep } = this.props;
        const postalCode = immInsuranceWizardStep.get('postalCode');
        return POSTAL_CODE_REGEX.test(postalCode) && postalCode.slice(0, 2);
    }

    handleSelectPlanModal(planIdx) {
        const { immInsuranceState, setData, recordEvent } = this.props;

        const plan = immInsuranceState.getIn(['recommendation', planIdx]);

        recordEvent(EVENTS_INSURANCE_HOME.STEP_2_OUR_GUIDE_BUTTON_CLICK, plan.get('type'));

        setData(SECOND_STEP, {
            content: plan.get('content'),
            minimumValueContent: plan.get('minimumValueContent'),
            percentContent: plan.get('percentContent'),
            type: plan.get('type'),
        });
    }

    buildContinentContentRelatedTitle() {
        const { immFlagBasedFeatures, immInsuranceWizardStep } = this.props;
        let contentAndContinentText = "step2ContentAndContinentRelatedText";
        const context = 'insuranceRelatedRequest-insuranceRelatedRequest_';
        const propertyCharacter = immInsuranceWizardStep.get('propertyCharacter');
        const isInsuranceRegulation = immFlagBasedFeatures.get(INSURANCE_IDD_REGULATION);

        let guaranteeMessage = isInsuranceRegulation && propertyCharacter === PROPERTY_CHARACTER.TENANT ? (
            __CONTACT_CENTER__ ?
                <BlockInfo extraClass="insurance-request-wizard-step-two__block-info">
                    {formatText(`${context}step2GuaranteesAsTenantCC`)}
                </BlockInfo>
                :
                <p>
                    {formatText(`${context}step2GuaranteesAsTenant`)}
                </p>
        ) : null;

        const titleRelatedContent = (
            <div className="row">
                <div className="col-xs-12">
                    <header className="insurance-request-wizard-step-two__header insurance-request-wizard-step-two__header--related">
                        <FormattedText value="insuranceRelatedRequest-step2ContentAndContinentRelatedTitle" />
                    </header>
                    <div className="insurance-request-wizard-step-two__text">
                        <FormattedText value={`insuranceRelatedRequest-${contentAndContinentText}`} />
                        {guaranteeMessage}
                    </div>
                </div>
            </div>
        );

        return titleRelatedContent;
    }

    buildPropertyCharacter(immInsuranceWizardStep) {
        const optionDisabledStep2Rent = this.isCombinedMortgaged();

        return (
            <div className="insurance-request-wizard-step-two__property-character col-sm-4 col-md-4">
                <RadioButtonGroup
                    className="insurance-request-wizard-step-two__radio-group"
                    idPrefix="propertyCharacterRadioGroup"
                    label={formatText('insuranceRequestHome-step2OwnerTenant')}
                    name="propertyCharacterRadioGroup"
                    onChange={this.handleChangePropertyCharacter}
                    selectedValue={immInsuranceWizardStep.get('propertyCharacter')}
                >
                    <RadioButton
                        label={formatText('insuranceRequestHome-owner')}
                        value={PROPERTY_CHARACTER.OWNER}
                    />
                    <RadioButton
                        disabled={optionDisabledStep2Rent}
                        label={formatText('insuranceRequestHome-tenant')}
                        value={PROPERTY_CHARACTER.TENANT}
                    />
                </RadioButtonGroup>
            </div>
        );
    }

    buildTooltip() {
        return (
            <OKTooltip
                content="insuranceRequestHome-insuranceRequestHome_step2PropertyUsageTooltip"
            />
        );
    }

    isCombinedMortgaged() {
        const {
            immFlagBasedFeatures,
            immInsuranceChosenMortgage,
        } = this.props;

        const isEnabledFF = immFlagBasedFeatures.get(STANDALONE_RELATED_INSURANCE);
        const contractNumber = immInsuranceChosenMortgage.getIn(['chosenMortgage', 'contractNumber']);
        return isEnabledFF && contractNumber !== undefined;
    }

    buildPropertyUsage(isOwner, immInsuranceWizardStep) {
        const {
            immFlagBasedFeatures,
        } = this.props;
        const propertyCharacter = immInsuranceWizardStep.get('propertyCharacter');
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const showTooltip = isInsuranceUsabilityImprovementsEnabled && isOwner;
        const optionalElement = showTooltip ? this.buildTooltip() : null;
        const optionDisabled = propertyCharacter !== '' && !isOwner;
        const optionDisabledStep2Rent = this.isCombinedMortgaged() || optionDisabled;

        return (
            <div className="insurance-request-wizard-step-two__property-usage col-sm-4 col-md-4">
                <RadioButtonGroup
                    className="insurance-request-wizard-step-two__radio-group"
                    idPrefix="propertyUsageRadioGroup"
                    label={formatText('insuranceRequestHome-step2PropertyUsage')}
                    name="propertyUsageRadioGroup"
                    onChange={value => this.handleChange('propertyUsage', value)}
                    optionalElement={optionalElement}
                    selectedValue={immInsuranceWizardStep.get('propertyUsage')}
                >
                    <RadioButton
                        label={formatText('insuranceRequestHome-step2Principal')}
                        value={PROPERTY_USAGE.PRINCIPAL}
                    />
                    <RadioButton
                        disabled={optionDisabled}
                        label={formatText('insuranceRequestHome-step2Secondary')}
                        value={PROPERTY_USAGE.SECONDARY}
                    />
                    <RadioButton
                        disabled={optionDisabledStep2Rent}
                        label={formatText('insuranceRequestHome-step2Rent')}
                        value={PROPERTY_USAGE.RENT}
                    />
                </RadioButtonGroup>
            </div>
        );
    }

    buildPropertyType(propertyTypeValue) {
        const {
            immFlagBasedFeatures,
        } = this.props;
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const placeholder = isInsuranceUsabilityImprovementsEnabled ? formatText('insuranceRequestHome-insuranceRequestHome_step2PropertyTypePlaceholder') : null;

        return (
            <div className="col-xs-12 col-md-4">
                <OKSelect
                    label={formatText('insuranceRequestHome-step2PropertyType')}
                    name="propertyTypeSelect"
                    onChange={op => this.handleChange('propertyType', op)}
                    options={getPropertyTypeOptions()}
                    placeholder={placeholder}
                    searchable={false}
                    value={propertyTypeValue}
                />
            </div>
        );
    }

    buildStepTwoSubtitle() {
        const StepTwoSubtitle = (
            <div className="row step-two-subtitle">
                <p className="col-xs-12">
                    <FormattedText value="insuranceRelatedRequest-step2SizeSubtitle" />
                </p>
            </div>
        );

        return StepTwoSubtitle;
    }

    buildSizeWarning(immInsuranceWizardStep, sizeMaxWithoutUnit, insurancesPhone) {
        const sizeWarningVisible = (immInsuranceWizardStep.get('size') === SIZE_SLIDER_CONFIG.MAX) && !__CONTACT_CENTER__;

        if (sizeWarningVisible) {
            return (
                <div className="insurance-request-wizard-step-two__message">
                    <OKMessage
                        id="insuranceRequestHomeSizeMessage"
                        type="important"
                        visible={sizeWarningVisible}
                    >
                        <FormattedText value="insuranceRequestHome-step2HighSize" injectedStrings={[sizeMaxWithoutUnit, SIZE_SLIDER_CONFIG.UNIT, insurancesPhone]} />
                    </OKMessage>
                </div>
            );
        } else {
            return null;
        }
    }

    buildHomeSizingComponente(insurancesPhone) {
        const {
            immInsuranceWizardStep,
        } = this.props;

        const step2SubTitle = this.buildStepTwoSubtitle();
        const sizeMinFormatted = `${formatAmount(SIZE_SLIDER_CONFIG.MIN, undefined, 0)}`;
        const sizeMaxFormatted = `${formatAmount(SIZE_SLIDER_CONFIG.MAX, undefined, 0)}`;
        const sizeMaxWithoutUnit = `${formatAmount(SIZE_SLIDER_CONFIG.MAX, undefined, 0)}`;
        const sizeWarningVisible = this.buildSizeWarning(immInsuranceWizardStep, sizeMaxWithoutUnit, insurancesPhone);
        const sliderLabel = <FormattedText value="insuranceRequestHome-step2SizeTitle" />;

        const homeSizingComponent = (
            <div className="row">
                <div className="col-xs-12">
                    <div className="insurance-request-wizard-step-two__slider">
                        <OKSliderInput
                            defaultValue={immInsuranceWizardStep.get('size')}
                            extraInfo={step2SubTitle}
                            inputType="format"
                            max={SIZE_SLIDER_CONFIG.MAX}
                            maxLabel={formatText('insuranceRequestHome-step2Max', [sizeMaxFormatted])}
                            min={SIZE_SLIDER_CONFIG.MIN}
                            minLabel={formatText('insuranceRequestHome-step2Min', [sizeMinFormatted])}
                            onChange={value => this.handleChange('size', value)}
                            title={sliderLabel}
                            unit={SIZE_SLIDER_CONFIG.UNIT}
                        />
                    </div>
                    {sizeWarningVisible}
                </div>
            </div>
        );

        return homeSizingComponent;
    }

    buildOkMessage(okMessageObj) {
        const okMessageBoxes = okMessageObj.map((okMessageBox, index) => {
            return (
                <div className="insurance-request-wizard-step-two__message" key={index} >
                    <OKMessage
                        id={okMessageBox.id}
                        type="important"
                        visible={okMessageBox.visible}
                    >
                        <FormattedText
                            injectedStrings={okMessageBox.injectedStrings}
                            value={okMessageBox.text}
                        />
                    </OKMessage>
                </div>
            )
        })

        return okMessageBoxes;
    }

    isSliderDisabled(value) {
        const { updateValues, postalCode } = this.state;
        const { immInsuranceState, immInsuranceWizardStep } = this.props;

        const insurancePostalCode = immInsuranceWizardStep.get('postalCode');
        const postalCodeError = !this.getProvinceId();
        const isFetchingRecommendation = immInsuranceState.get('isFetchingRecommendation');

        return postalCodeError || insurancePostalCode !== postalCode || !value ||
            updateValues && (isFetchingRecommendation || immInsuranceState.get('recommendation').size === 0);
    }

    buildContentSliderComponent() {
        const { maxContentPassed } = this.state;
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep
        } = this.props;

        const recommendationsData = immInsuranceState.get('recommendation');
        const insurancesRecommendationFactors = !!immFlagBasedFeatures.get(INSURANCES_RECOMMENDATION_FACTORS);
        const defaultMinimumValueContent = recommendationsData.getIn([0, 'defaultMinimumValueContent'], CONTENT_SLIDER_CONFIG.MIN);
        const contentMinValue = insurancesRecommendationFactors ? defaultMinimumValueContent : CONTENT_SLIDER_CONFIG.MIN;
        const maxContentValue = this.getMaxContentValue();
        const contentMaxFormatted = formatText('insuranceRequestHome-step2Max', [formatAmount(maxContentValue, undefined, 0)]);
        const contentMinFormatted = formatText('insuranceRequestHome-step2Min', [formatAmount(contentMinValue, undefined, 0)]);
        const insurancesPhone = formatText('insuranceRequestHome-openbankInsurancesPhone');
        const contentDefaultValue = immInsuranceWizardStep.get('content');
        const continentDefaultValue = immInsuranceWizardStep.get('continent');
        const isOwnerAndContentIsGreaterThanContinent = immInsuranceWizardStep.get('propertyCharacter') === PROPERTY_CHARACTER.OWNER && (contentDefaultValue > continentDefaultValue);
        const isContentDisabled = this.isSliderDisabled(contentDefaultValue);
        const isLowContentWarningVisible = this.isLowContentWarningVisible();
        const disclaimerContentLimitExceededCC = __CONTACT_CENTER__ ? this.buildDisclaimerContentLimitExceededCC() : null;
        const okMessageContent = [
            {
                id: 'insuranceRequestHomeContentMessage',
                injectedStrings: [],
                text: 'insuranceRequestHome-step2LowContent',
                visible: isLowContentWarningVisible,
            },
            {
                id: 'insuranceRequestHomeMaxContentMessage',
                injectedStrings: [maxContentValue, EURO_SYMBOL, insurancesPhone],
                text: 'insuranceRequestHome-step2ContentMaxReachedMsg',
                visible: maxContentPassed && !__CONTACT_CENTER__,
            },
            {
                id: 'insuranceRequestHomecontentGreaterThanContinent',
                injectedStrings: [],
                text: 'insuranceRequestHome-insuranceRequestHome_contentGreaterThanContinentMessage',
                visible: insurancesRecommendationFactors && isOwnerAndContentIsGreaterThanContinent,
            },
        ]

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="insurance-request-wizard-step-two__slider insurance-request-wizard-step-two__slider--small">
                        <InsurancesRequestWizardStep2SliderLabel
                            labelName={"insuranceRequestHome-summaryContent"}
                            tooltipCont={'insuranceRequestHome-step2ContentTooltip'}
                        />
                        <OKSliderInput
                            defaultValue={contentDefaultValue}
                            disabled={isContentDisabled}
                            id="insuranceRequestHomeContentSlider"
                            inputType="format"
                            max={maxContentValue}
                            maxLabel={contentMaxFormatted}
                            min={contentMinValue}
                            minLabel={contentMinFormatted}
                            onChange={this.handleChangeContent}
                            step={100}
                            unit={EURO_SYMBOL}
                        />
                    </div>
                    {disclaimerContentLimitExceededCC}
                    {this.buildOkMessage(okMessageContent)}
                </div>
            </div>
        )
    }

    getMaxContentValue() {
        const { immInsuranceState } = this.props;
        const recommendationsData = immInsuranceState.get('recommendation');
        const defaultMax = __CONTACT_CENTER__ ? CONTENT_SLIDER_CONFIG.MAX_PRINCIPAL_CC : CONTENT_SLIDER_CONFIG.MAX;

        return recommendationsData.getIn([0, 'defaultMaxValueContent'], defaultMax);
    }

    isLowContentWarningVisible() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
        } = this.props;

        const maxContentValue = this.getMaxContentValue();
        const content = immInsuranceWizardStep.get('content');
        const contentIsNotDisabled = !this.isSliderDisabled(content);
        const isContentLimitExceedCC = this.isContentLimitExceededCC();
        const minimumValueContent = !!immFlagBasedFeatures.get(INSURANCES_RECOMMENDATION_FACTORS) ?
            immInsuranceState.getIn(['recommendation', 0, 'minimumValueContent']) :
            immInsuranceState.getIn(['recommendation', 0, 'content']);
        const contentWarningVisible = content < minimumValueContent && content < maxContentValue;
        const lowContentWarningVisible = contentWarningVisible && contentIsNotDisabled;

        return isContentLimitExceedCC ? false : lowContentWarningVisible;
    }

    buildDisclaimerContentLimitExceededCC() {
        const isContentLimitExceedCC = this.isContentLimitExceededCC();
        const maxContentValueWeb = this.getMaxContentValue();
        const poEditorPrefix = 'insuranceRequestHomeCC-insuranceRequestHomeCC';

        return (
            <div className="insurance-request-wizard-step-two__content-limited-exceeded">
                <OKMessage
                    id="contentLimitExceededCC"
                    type="important"
                    visible={isContentLimitExceedCC}
                >
                    <FormattedText
                        value={`${poEditorPrefix}_disclaimerMessageContentLimitedExceeded`}
                        injectedStrings={[formatAmount(maxContentValueWeb, undefined, 0), EURO_SYMBOL]} />
                </OKMessage>
            </div>
        );
    }

    isContentLimitExceededCC() {
        const { immInsuranceWizardStep } = this.props;

        const maxContentValueWeb = this.getMaxContentValue();
        let contentLimitExceeded = false;

        if (__CONTACT_CENTER__) {
            contentLimitExceeded = immInsuranceWizardStep.get('content') > maxContentValueWeb;
        }

        return contentLimitExceeded;
    }

    buildStepValidationError() {
        return (
            <div className="row">
                <div className="col-xs-12 insurance-request-wizard-step-two__field-errors-message">
                    <OKMessage type="warning">
                        <FormattedText value="insuranceRequestHome-stepValidationError" />
                    </OKMessage>
                </div>
            </div>
        );
    }

    buildWizardGuide(recommendationsData, showGuideModal, showGuideText) {
        const {
            immInsuranceWizardStep,
        } = this.props;

        const populationDisable = immInsuranceWizardStep.get('isFetchingSelectPopulation') ||
            !immInsuranceWizardStep.get('populationOptions').size;

        return !populationDisable ? (
            <InsuranceRequestWizardGuide
                onHandleToggleModal={this.handleToggleModal}
                onSelectPlanModal={this.handleSelectPlanModal}
                recommendationsData={recommendationsData}
                showGuideModal={showGuideModal}
                showGuideText={showGuideText}
            />
        ) : null;
    }

    buildContinentSliderContent() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
        } = this.props;
        const recommendationsData = immInsuranceState.get('recommendation');
        const continentDefaultValue = immInsuranceWizardStep.get('continent');
        const continentDisabled = this.isSliderDisabled(continentDefaultValue);
        const continentTooltip = 'insuranceRequestHome-step2ContinentTooltip';
        const insurancesRecommendationFactors = !!immFlagBasedFeatures.get(INSURANCES_RECOMMENDATION_FACTORS);
        const defaultMinimumValueContinent = recommendationsData.getIn([0, 'defaultMinimumValueContinent'], CONTINENT_SLIDER_CONFIG.MIN);
        const continentMinValue = insurancesRecommendationFactors ? defaultMinimumValueContinent : CONTINENT_SLIDER_CONFIG.MIN;
        const isOwner = immInsuranceWizardStep.get('propertyCharacter') === PROPERTY_CHARACTER.OWNER;
        const continentMaxValue = recommendationsData.getIn([0, 'defaultMaxValueContinent'], CONTINENT_SLIDER_CONFIG.MAX);
        const continentMinFormatted = formatAmount(continentMinValue, undefined, 0);
        const continentMaxFormatted = formatAmount(continentMaxValue, undefined, 0);
        const continentWarningVisible = isOwner && immInsuranceWizardStep.get('continent') === continentMaxValue;
        const insurancesPhone = formatText('insuranceRequestHome-openbankInsurancesPhone');
        const { lowContinentWarningVisible } = this.state;
        const supraContinent = recommendationsData.getIn([0, 'maxValueContinent']);
        const continentRecommendation = recommendationsData.getIn([0, 'continent']);
        const okMessageContinent = [
            {
                id: 'insuranceRequestHomeContinentMessage',
                injectedStrings: [continentMaxFormatted, EURO_SYMBOL, insurancesPhone],
                text: 'insuranceRequestHome-step2HighContinent',
                visible: continentWarningVisible && !__CONTACT_CENTER__,
            },
            {
                id: 'insuranceRequestHomeLowContinentMessage',
                injectedStrings: [],
                text: 'insuranceRequestHome-step2LowContinent',
                visible: lowContinentWarningVisible && !continentDisabled,
            },
            {
                id: 'insuranceRequestHomeSupraContinentMessage',
                injectedStrings: [],
                text: 'insuranceRequestHome-insuranceRequestHome_supraInsuranceMessage',
                visible: isOwner && !!supraContinent && supraContinent !== continentRecommendation && continentDefaultValue > supraContinent,
            },
        ];

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="insurance-request-wizard-step-two__slider insurance-request-wizard-step-two__slider--small">
                        <InsurancesRequestWizardStep2SliderLabel
                            continentIcon={true}
                            continentValue={continentMinFormatted}
                            labelName={"insuranceRequestHome-summaryContinent"}
                            minMaxValues={CONTINENT_SLIDER_CONFIG}
                            tooltipCont={continentTooltip}
                        />
                        <OKSliderInput
                            defaultValue={continentDefaultValue}
                            disabled={continentDisabled}
                            id="insuranceRequestHomeContinentSlider"
                            inputType="format"
                            max={continentMaxValue}
                            maxLabel={formatText('insuranceRequestHome-step2Max', [continentMaxFormatted])}
                            min={continentMinValue}
                            minLabel={formatText('insuranceRequestHome-step2Min', [continentMinFormatted])}
                            onChange={this.handleChangeContinent}
                            step={100}
                            unit={EURO_SYMBOL}
                        />
                    </div>
                    {this.buildOkMessage(okMessageContinent)}
                </div>
            </div>
        );
    }

    buildContinentAndContendSliders() {
        const {
            immInsuranceState,
            immInsuranceWizardStep,
        } = this.props;
        const recommendationsData = immInsuranceState.get('recommendation');
        const maxContentValidation = this.getMaxContentValue();
        const recommendationsDataToJS = recommendationsData.toJS();
        const recommendationsExceedMax = recommendationsDataToJS.filter(plan => plan.content > maxContentValidation);
        const isFetchingRecommendation = immInsuranceState.get('isFetchingRecommendation');
        const contentDefaultValue = immInsuranceWizardStep.get('content');
        const continentDefaultValue = immInsuranceWizardStep.get('continent');
        const contentDisabled = this.isSliderDisabled(contentDefaultValue);
        const continentDisabled = this.isSliderDisabled(continentDefaultValue);
        const showGuideModal = !isFetchingRecommendation && continentDefaultValue &&
            !continentDisabled && !contentDisabled;
        const showGuideText = recommendationsDataToJS.length > 0 && !recommendationsExceedMax.length && showGuideModal;
        const contentAndContinentRelatedTitle = this.buildContinentContentRelatedTitle();
        const continent = this.buildContinentSliderContent();
        const content = this.buildContentSliderComponent();
        const wizardGuide = this.buildWizardGuide(recommendationsDataToJS, showGuideModal, showGuideText);

        return (
            <React.Fragment>
                {contentAndContinentRelatedTitle}
                {continent}
                {content}
                {wizardGuide}
            </React.Fragment>
        );
    }

    render() {
        const {
            changeErrorPopulation,
            changeErrorPostalCode,
            clearPostalCodeError,
            getPopulationData,
            immFlagBasedFeatures,
            immInsuranceWizardStep,
            recordEvent,
            setData,
        } = this.props;
        const { disablePostalCode } = this.state;
        const isOwner = immInsuranceWizardStep.get('propertyCharacter') === PROPERTY_CHARACTER.OWNER;
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const stepValidationError = !isInsuranceUsabilityImprovementsEnabled && immInsuranceWizardStep.get('fieldErrors') ? this.buildStepValidationError() : null;
        const propertyTypeValue = immInsuranceWizardStep.get('propertyType');
        const insurancesPhone = formatText('insuranceRequestHome-openbankInsurancesPhone');
        const propertyCharacterComponent = this.buildPropertyCharacter(immInsuranceWizardStep);
        const propertyUsageComponent = this.buildPropertyUsage(isOwner, immInsuranceWizardStep);
        const propertyTypeComponent = this.buildPropertyType(propertyTypeValue);
        const isValid = immInsuranceWizardStep.get('valid');
        const continentAndContent = !isInsuranceUsabilityImprovementsEnabled || isValid ? this.buildContinentAndContendSliders() : null;

        return (
            <div className="insurance-request-wizard-step-two">
                <div className="row">
                    <header className="insurance-request-wizard-step-two__header">
                        <FormattedText value="insuranceRequestHome-step2Title" />
                    </header>
                </div>
                {stepValidationError}
                <div className="row">
                    {propertyCharacterComponent}
                    {propertyUsageComponent}
                    {propertyTypeComponent}
                </div>
                <div className="row">
                    <InsuranceRequestPostalCodePopulation
                        changeErrorPopulation={changeErrorPopulation}
                        changeErrorPostalCode={changeErrorPostalCode}
                        clearPostalCodeError={clearPostalCodeError}
                        getPopulationData={getPopulationData}
                        immInsuranceWizardStep={immInsuranceWizardStep}
                        recordEvent={recordEvent}
                        saveAndRequestRecommendation={this.saveAndRequestRecommendation}
                        disablePostalCode={disablePostalCode}
                        setData={setData}
                    />
                </div>
                {this.buildHomeSizingComponente(insurancesPhone)}
                {continentAndContent}
            </div>
        );
    }
}

InsuranceRequestWizardStep2.propTypes = {
    changeErrorPopulation: PropTypes.func.isRequired,
    changeErrorPostalCode: PropTypes.func.isRequired,
    clearPostalCodeError: PropTypes.func.isRequired,
    getPopulationData: PropTypes.func.isRequired,
    getRecommendation: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    insuranceRequestFreeStarted: PropTypes.func.isRequired,
    insuranceRequesCombinedStarted: PropTypes.func.isRequired,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    recordEvent: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    immInsuranceChosenMortgage: PropTypes.object.isRequired,
};

module.exports = InsuranceRequestWizardStep2;
